import React, { JSX } from "react";
import { nanoid } from "nanoid";

// Define the structure of a field
export interface Field {
  id: string
  type: string;
  title: string;
  category: string;
  icon: string | null;
  size: number;
}

// Define the structure of the renderers
interface AppTopBarProps {
  appBarPreview: string; // appBarPreview deve ser uma string (URL da imagem)
}

export const AppTopBar: React.FC<AppTopBarProps> = ({ appBarPreview }) => {
  return (
    <div>
      <div className="topbar">
        <span>12:00</span>
        <span>
          <i className="fas fa-wifi"></i>
          <i className="fas fa-signal"></i>
        </span>
      </div>
      <div className="appbar">
        <img className="appbar-logo" src={appBarPreview} alt="App Bar" />
        <span>
          <i className="fas fa-search"></i>
          <i className="fas fa-cog"></i>
        </span>
      </div>
    </div>
  );
};

interface MenuItem {
  key: string;
  icon: JSX.Element;
  label: string;
}

type AppNavBarProps = {
  activeItem: string;
};

export const AppNavBar: React.FC<AppNavBarProps> = ({ activeItem }) => {
  const menuItems: MenuItem[] = [
    { key: "home", icon: <i className="fas fa-home"></i>, label: "Home" },
    { key: "tv", icon: <i className="fas fa-tv"></i>, label: "TV" },
    {
      key: "radio",
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" width="32" height="32">
          <path d="M2 9a2 2 0 0 1 2-2h7.585l4.707-4.707a1 1 0 1 1 1.414 1.414L14.414 7H20a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V9zm2 0v10h16V9H4zm8 5a3 3 0 1 1-6 0 3 3 0 0 1 6 0zm-3 1a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm6-4a1 1 0 0 1 1-1h3a1 1 0 1 1 0 2h-3a1 1 0 0 1-1-1zm0 3a1 1 0 0 1 1-1h3a1 1 0 1 1 0 2h-3a1 1 0 0 1-1-1zm0 3a1 1 0 0 1 1-1h3a1 1 0 1 1 0 2h-3a1 1 0 0 1-1-1z" />
        </svg>
      ),
      label: "Rádio",
    },
    { key: "news", icon: <i className="fas fa-newspaper"></i>, label: "Notícias" },
    { key: "more", icon: <i className="fas fa-plus-circle"></i>, label: "Mais" },
  ];

  return (
    <div>
      <div className="navbar">
        {menuItems.map((item) => (
          <div key={item.key} className={`icon-box ${activeItem === item.key ? "active" : ""} ${item.key === "radio" ? "svg" : ""}`}>
            {item.icon}
            {item.label}
          </div>
        ))}
      </div>
    </div>
  );
};

// Define the structure of the renderers
export type Renderers = {
  [key: string]: () => JSX.Element;
};

// Fields available in the sidebar
export const fields: Field[] = [
  { id: nanoid(), type: "agenda", title: "Agenda Mensal", icon: "fas fa-calendar-day", size: 1, category: 'general' },
  { id: nanoid(), type: "audios", title: "Áudios / Podcast", icon: "fas fa-podcast", size: 1, category: 'general' },
  { id: nanoid(), type: "image",  title: "Banner Fixo", icon: "fas fa-image", size: 3, category: 'general' },
  { id: nanoid(), type: "slider",  title: "Banners Rotativo", icon: "fas fa-images", size: 3, category: 'general' },
  { id: nanoid(), type: "bible", title: "Bíblia", icon: "fas fa-bible", size: 1, category: 'church' },
  { id: nanoid(), type: "devotions", title: "Devocional", icon: "fas fa-pray", size: 1, category: 'church' },
  { id: nanoid(), type: "donate_full", title: "Dízimos e Ofertas", icon: "fas fa-hand-holding-medical", size: 3, category: 'church' },
  { id: nanoid(), type: "donate", title: "Doar / Contribuir", icon: "fas fa-hand-holding-medical", size: 1, category: 'general' },
  { id: nanoid(), type: "downloads", title: "Downloads (PDF)", icon: "fas fa-file-alt", size: 1 , category: 'general'},
  { id: nanoid(), type: "persons", title: "Equipe", icon: "fas fa-users", size: 1, category: 'general' },
  { id: nanoid(), type: "studies", title: "Estudos Bíblicos", icon: "fas fa-book", size: 1, category: 'church' },
  { id: nanoid(), type: "events", title: "Eventos", icon: "fas fa-calendar-day", size: 1, category: 'general' },
  { id: nanoid(), type: "next_events", title: "Eventos Próximos", icon: "fas fa-calendar-day", size: 3, category: 'church' },
  { id: nanoid(), type: "contact", title: "Fale Conosco", icon: "fas fa-envelope", size: 1 , category: 'general'},
  { id: nanoid(), type: "churchs", title: "Igrejas", icon: "fas fa-place-of-worship", size: 1, category: 'church' },
  { id: nanoid(), type: "directory", title: "Guia Comercial", icon: "fas fa-bullhorn", size: 1, category: 'general' },
  { id: nanoid(), type: "web", title: "Link para Site Externo", icon: "fas fa-link", size: 1, category: 'general' },
  { id: nanoid(), type: "location", title: "Localização", icon: "fas fa-map-marked", size: 1, category: 'general' },
  { id: nanoid(), type: "music", title: "Mais Tocadas", icon: "fas fa-music", size: 1, category: 'general' },
  { id: nanoid(), type: "ministries", title: "Ministérios (Igreja)", icon: "fas fa-house-user", size: 1, category: 'church' },
  { id: nanoid(), type: "mission", title: "Missões", icon: "fas fa-globe", size: 1, category: 'church' },
  { id: nanoid(), type: "social", title: "Nossas Páginas", icon: "fas fa-globe", size: 1, category: 'general' },
  { id: nanoid(), type: "news", title: "Notícias", icon: "fas fa-newspaper", size: 1, category: 'general' },
  { id: nanoid(), type: "news_full", title: "Notícias (Lista)", icon: "fas fa-newspaper", size: 3, category: 'general' },
  { id: nanoid(), type: "song_request", title: "Pedir Música", icon: "fas fa-music", size: 1, category: 'general' },
  { id: nanoid(), type: "pray", title: "Pedir Oração", icon: "fas fa-praying-hands", size: 1, category: 'church' },
  { id: nanoid(), type: "groups", title: "Pequenos Grupos", icon: "fas fa-users", size: 1, category: 'church' },
  { id: nanoid(), type: "programs", title: "Programas", icon: "fas fa-th-large", size: 1, category: 'general' },
  { id: nanoid(), type: "schedule", title: "Programação", icon: "fas fa-calendar-alt", size: 1, category: 'general' },
  { id: nanoid(), type: "radio_box", title: "Rádio", icon: "fas fa-music", size: 1, category: 'general' },
  { id: nanoid(), type: "guestbook", title: "Recados", icon: "fas fa-comment", size: 1, category: 'general' },
  { id: nanoid(), type: "pages", title: "Quem Somos", icon: "fas fa-house-user", size: 1, category: 'general' },
  { id: nanoid(), type: "tv_full", title: "Minit TV", icon: "fas fa-tv", size: 3, category: 'general' },
  { id: nanoid(), type: "tv", title: "TV", icon: "fas fa-tv", size: 1, category: 'general' },
  { id: nanoid(), type: "live", title: "YouTube Ao Vivo", icon: "fas fa-play-circle", size: 1, category: 'general' },
  { id: nanoid(), type: "youtube_videos", title: "Vídeos do YouTube", icon: "fab fa-youtube", size: 1, category: 'general' },
  { id: nanoid(), type: "youtube_videos_full", title: "Vídeos do YouTube (Lista)", icon: "fab fa-youtube", size: 3, category: 'general' },
  { id: nanoid(), type: "videos", title: "Vídeos do Site", icon: "fas fa-play", size: 3, category: 'general' },
];

// Define how each field is rendered
export const renderers: Renderers = {
  image: () => <img className="el" src="https://build.zas.media/images/banner.jpg" alt="Banner" />,
  slider: () => (
    <div className="carousel">
      <div className="carousel-track">
        <img className="el" src="https://build.zas.media/images/banner-2.jpg" alt="Slide 2" />
        <img className="el" src="https://build.zas.media/images/banner-3.jpg" alt="Slide 3" />
        <img className="el" src="https://build.zas.media/images/banner.jpg" alt="Slide 1" />
      </div>
    </div>
  ),
  tv_full: () => (
    <div className="el dash-tv">
      <img src="https://build.zas.media/images/tv.jpg" alt="Mini TV" />
      <div>
        <strong>Web TV</strong>
        <span>Acompanhe nossa programação</span>
      </div>
    </div>
  ),
  news: () => (
    <div className="el icon-box">
      <i className="fas fa-newspaper"></i>
      Notícias
    </div>
  ),
  news_full: () => (
    <div className="hList">
      <div className="topEl w-full">
        <span>Notícias</span>
        <button>Ver Todas</button>
      </div>
      <ul>
        <li>
          <img className="el" src="/images/noticia-1.jpg"/>
          <span className="wrap">BC autoriza pagamento de boletos por Pix a partir desta 2ª</span>
        </li>
        <li>
          <img className="el" src="/images/noticia-2.jpg"/>
          <span className="wrap">Em pesquisa inédita, alunos brasileiros descobrem</span>
        </li>
        <li>
          <img className="el" src="/images/noticia-3.jpg"/>
          <span className="wrap">Trânsito em São Paulo duplica em 5 anos</span>
        </li>
      </ul>
    </div>
  ),
  videos: () => (
    <div className="hList">
      <div className="topEl">
        <span>Vídeos</span>
        <button>Ver Todos</button>
      </div>
      <ul>
        <li>
          <img className="el" src="https://build.zas.media/images/video-1.jpg"/>
          <span>Peru descobre nova pirâmide de civilização mais antiga da América</span>
        </li>
        
        <li>
          <img className="el" src="https://build.zas.media/images/video-3.jpg"/>
          <span>Nasa afirma que asteroide irá passar perto da terra</span>
        </li>
        <li>
          <img className="el" src="https://build.zas.media/images/video-2.jpg"/>
          <span>Conta de luz aumenta com a falta de chuvas</span>
        </li>
      </ul>
    </div>
  ),
  youtube_videos: () => (
    <div className="el icon-box">
      <i className="fab fa-youtube"></i>
      Vídeos
    </div>
  ),
  youtube_videos_full: () => (
    <div className="hList">
      <div className="topEl w-full">
        <span>Vídeos</span>
        <button>Ver Todos</button>
      </div>
      <ul>
        <li>
          <img className="el" src="/images/video-1.jpg"/>
          <span>Peru descobre nova pirâmide de civilização mais antiga da América</span>
        </li>
        
        <li>
          <img className="el" src="/images/video-3.jpg"/>
          <span>Nasa afirma que asteroide irá passar perto da terra</span>
        </li>
        <li>
          <img className="el" src="/images/video-2.jpg"/>
          <span>Conta de luz aumenta com a falta de chuvas</span>
        </li>
      </ul>
    </div>
  ),
  persons: () => (
    <div className="el icon-box">
      <i className="fas fa-users"></i>
      Equipe
    </div>
  ),
  programs: () => (
    <div className="el icon-box">
      <i className="fas fa-th-large"></i>
      Programas
    </div>
  ),
  music: () => (
    <div className="el icon-box">
      <i className="fas fa-music"></i>
      Mais Tocadas
    </div>
  ),
  events: () => (
    <div className="el icon-box">
      <i className="fas fa-calendar-day"></i>
      Eventos
    </div>
  ),
  directory: () => (
    <div className="el icon-box">
      <i className="fas fa-bullhorn"></i>
      Guia Comercial
    </div>
  ),
  song_request: () => (
    <div className="el icon-box">
      <i className="fas fa-music"></i>
      Pedir Música
    </div>
  ),
  audios: () => (
    <div className="el icon-box">
      <i className="fas fa-podcast"></i>
      Podcast
    </div>
  ),
  guestbook: () => (
    <div className="el icon-box">
      <i className="fas fa-comment"></i>
      Recados
    </div>
  ),
  radio_box: () => (
    <div className="el icon-box svg">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        fill="currentColor"
        width="40"
        height="40"
      >
        <path d="M2 9a2 2 0 0 1 2-2h7.585l4.707-4.707a1 1 0 1 1 1.414 1.414L14.414 7H20a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V9zm2 0v10h16V9H4zm8 5a3 3 0 1 1-6 0 3 3 0 0 1 6 0zm-3 1a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm6-4a1 1 0 0 1 1-1h3a1 1 0 1 1 0 2h-3a1 1 0 0 1-1-1zm0 3a1 1 0 0 1 1-1h3a1 1 0 1 1 0 2h-3a1 1 0 0 1-1-1zm0 3a1 1 0 0 1 1-1h3a1 1 0 1 1 0 2h-3a1 1 0 0 1-1-1z" />
      </svg>
      Rádio
    </div>
  ),
  schedule: () => (
    <div className="el icon-box">
      <i className="fas fa-calendar-alt"></i>
      Programação
    </div>
  ),
  pages: () => (
    <div className="el icon-box">
      <i className="fas fa-house-user"></i>
      Quem Somos
    </div>
  ),
  location: () => (
    <div className="el icon-box">
      <i className="fas fa-map-marked"></i>
      Localização
    </div>
  ),
  social: () => (
    <div className="el icon-box">
      <i className="fas fa-globe"></i>
      Nossas Páginas
    </div>
  ),
  contact: () => (
    <div className="el icon-box">
      <i className="far fa-envelope"></i>
      Fale Conosco
    </div>
  ),
  tv: () => (
    <div className="el icon-box">
      <i className="fas fa-tv"></i>
      TV
    </div>
  ),
  live: () => (
    <div className="el icon-box">
      <i className="far fa-play-circle"></i>
      Ao Vivo
    </div>
  ),
  donate: () => (
    <div className="el icon-box">
      <i className="fas fa-hand-holding-medical"></i>
      Doar
    </div>
  ),
  agenda: () => (
    <div className="el icon-box">
      <i className="fas fa-calendar-day"></i>
      Agenda
    </div>
  ),
  bible: () => (
    <div className="el icon-box">
      <i className="fas fa-bible"></i>
      Bíblia
    </div>
  ),
  devotions: () => (
    <div className="el icon-box">
      <i className="fas fa-pray"></i>
      Devocional
    </div>
  ),
  donate_full: () => (
    <div className="el dash-tv">
      <div>
        <strong>Ofertas e Dízimos</strong>
        <span>Semeia na Obra do Senhor</span>
      </div>
      <img src="https://build.zas.media/images/ofertar.jpg" alt="Ofertar" />
    </div>
  ),
  downloads: () => (
    <div className="el icon-box">
      <i className="fas fa-file-alt"></i>
      Downloads
    </div>
  ),
  studies: () => (
    <div className="el icon-box">
      <i className="fas fa-book"></i>
      <span className="shrink">Estudos Bíblicos</span>
    </div>
  ),
  next_events: () => (
    <div className="el dash-tv">
      <img src="https://build.zas.media/images/evento.jpg" alt="Mini TV" />
      <div>
        <strong>Motivando Todos para a Qualidade</strong>
        <span>Sábado, 28/04 às 19h00</span>
      </div>
    </div>
  ),
  churchs: () => (
    <div className="el icon-box">
      <i className="fas fa-place-of-worship"></i>
      Igrejas
    </div>
  ),
  web: () => (
    <div className="el icon-box">
      <i className="fas fa-link"></i>
      Link Externo
    </div>
  ),
  ministries: () => (
    <div className="el icon-box">
      <i className="fas fa-house-user"></i>
      Ministérios
    </div>
  ),
  mission: () => (
    <div className="el icon-box">
      <i className="fas fa-globe"></i>
      Missões
    </div>
  ),
  pray: () => (
    <div className="el icon-box">
      <i className="fas fa-praying-hands"></i>
      Pedir Oração
    </div>
  ),
  groups: () => (
    <div className="el icon-box">
      <i className="fas fa-users"></i>
      <span className="shrink">Pequenos Grupos</span>
    </div>
  ),
};

export const getScreens = (appBarPreview: string, radioLogoPreview: string, logoPreview: string): Renderers => ({
  home: () => (
    <div className="mockup-phone">
      <div className="camera">
        <div className='text-white text-center'>Home</div>
      </div>
      <div className="display pb-10 app-bg">
        <div className="artboard phone-1 app-mini">
          <div className='flex flex-col justify-between h-full app-radio'>
            <AppTopBar appBarPreview={appBarPreview} />
            <div className='relative h-full'>
              <div className='app-home'>
                {renderers.image()}
                {renderers.tv_full()}
                {renderers.news()}
                <div className='grid grid-cols-3 gap-3 mt-3'>
                  {renderers.persons()}
                  {renderers.programs()}
                  {renderers.schedule()}
                </div>
                {renderers.videos()}
              </div>
            </div>
            <AppNavBar activeItem="home" />
          </div>
        </div>
      </div>
    </div>
  ),
  radio: () => (
    <div className="mockup-phone">
      <div className="camera">
        <div className='text-white text-center'>Rádio</div>
      </div>
      <div className="display pb-10 app-bg">
        <div className="artboard phone-1 app-mini">
          <div className='flex flex-col justify-between h-full app-radio'>
            <div className='flex flex-col justify-between h-full'>
              <div className='flex justify-center items-center w-full mt-10 logo'>
                <img src={radioLogoPreview} className='app-radio-logo' alt="Rádio Logo" />
              </div>
              <div className='flex flex-col items-center'>
                <div className='playing-now'>TOCANDO AGORA</div>
                <div className='playing-title mt-2'>Web Rádio</div>
              </div>
              <div className="radio-controls">
                <div className='controls'>
                  <div className='flex justify-between items-center'>
                    <i className="fa-solid fa-music"></i>
                    <div className='play'>
                      <i className="fas fa-play"></i>
                    </div>
                    <i className="fa-solid fa-share-nodes"></i>
                  </div>
                </div>
              </div>
            </div>
            <AppNavBar activeItem="radio" />
          </div>
        </div>
      </div>
    </div>
  ),
  tv: () => ( 
    <div className="mockup-phone">
      <div className="camera">
        <div className='text-white text-center'>TV</div>
      </div>
      <div className="display pb-10 app-bg">
        <div className="artboard phone-1 app-mini">
          <div className='flex flex-col justify-between h-full app-radio'>
            <AppTopBar appBarPreview={appBarPreview} />
            <div className='relative h-full app-tv'>
              <img src="https://build.zas.media/images/tv.jpg" alt="Mini TV" />
              <div className="tabs tabs-border">
                <input type="radio" name="my_tabs_2" className="tab" aria-label="Programação" defaultChecked/>
                <div className="tab-content p-3">
                  <div className='flex justify-between items-center'>
                    <div>
                      <div className='font-bold'>No ar até as 19:00</div>
                      <div className='font-bold app-secondary text-xl'>Músical Total</div>
                    </div>
                    <i className="fa-solid fa-chevron-right text-2xl"></i>
                  </div>
                  <div className='flex justify-center mt-3'>
                    <div className='share flex'>
                      <div className='font-bold'>Compartilhe</div>
                      <ul className='flex'>
                        <li className='icon-wa'><i className="fa-brands fa-whatsapp"></i></li>
                        <li className='icon-fb'><i className="fa-brands fa-facebook"></i></li>
                        <li className='icon-x'><i className="fab fa-twitter"></i></li>
                        <li className='icon-ma'><i className="fa-solid fa-envelope"></i></li>
                        <li className='icon-sh'><i className="fa-solid fa-share"></i></li>
                      </ul>
                    </div>
                  </div>
                  <div className='font-bold mt-4'>Próximas Transmissões</div>
                  <div className='programs'>
                    <div className='el flex items-center mt-3'>
                      <img src="https://build.zas.media/images/programa-jornal-brasil.jpg" alt="Programa" />
                      <div>
                        <div className='info'>
                          <i className="far fa-clock"></i> Hoje das 20:00 às 22:00
                        </div>
                        <div className='font-bold'>Jornal Brasil</div>
                      </div>
                      <label className="switch"><input type="checkbox" /><span className="slider"></span></label>
                    </div>
                    <div className='el flex items-center mt-3'>
                      <img src="https://build.zas.media/images/programa-show-da-noite.jpg" alt="Programa" />
                      <div>
                        <div className='info'>
                          <i className="far fa-clock"></i> Hoje das 22:00 às 23:00
                        </div>
                        <div className='font-bold'>Show da Noite</div>
                      </div>
                      <label className="switch"><input type="checkbox" /><span className="slider"></span></label>
                    </div>
                  </div>
                </div>
                <input type="radio" name="my_tabs_2" className="tab" aria-label="Bíblia" />
                <input type="radio" name="my_tabs_2" className="tab" aria-label="Anúncios" />
                <input type="radio" name="my_tabs_2" className="tab" aria-label="Vídeos" />
              </div>
            </div>
            <AppNavBar activeItem="tv" />
          </div>
        </div>
      </div>
    </div>
  ),
  news: () => ( 
    <div className="mockup-phone">
    <div className="camera">
      <div className='text-white text-center'>Notícias</div>
    </div>
    <div className="display pb-10 app-bg">
      <div className="artboard phone-1 app-mini">
        <div className='flex flex-col justify-between h-full '>
          <AppTopBar appBarPreview={appBarPreview} />
          <div className='relative h-full app-news'>
            <div className='el p-2'>
              <img src="https://build.zas.media/images/noticia-1.jpg"/>
              <span className="font-bold wrap mt-3">BC autoriza pagamento de boletos por Pix a partir desta 2ª</span>
              <span className='info'><i className="far fa-clock"></i> há 4 horas</span>
            </div>
            <div className='el p-2 mt-3'>
              <div className='flex horiz'>
                <div>
                  <span className="font-bold wrap mt-3">Em pesquisa inédita, alunos brasileiros descobrem...</span>
                  <span className='info'><i className="far fa-clock"></i> há 9 horas</span>
                </div>
                <img src="https://build.zas.media/images/noticia-2.jpg"/>
              </div>
            </div>
            <div className='el p-2 mt-3'>
              <img src="https://build.zas.media/images/noticia-3.jpg"/>
              <span className="font-bold wrap mt-3">Trânsito em São Paulo duplica em 5 anos</span>
              <span className='info'><i className="far fa-clock"></i> há 1 dia</span>
            </div>
          </div>
          <AppNavBar activeItem="news" />
        </div>
      </div>
    </div>
  </div>
  ),
  new: () => ( 
    <div className="mockup-phone">
      <div className="camera">
        <div className='text-white text-center'>Notícia</div>
      </div>
      <div className="display pb-10 app-bg">
        <div className="artboard phone-1 app-mini">
          <div className='flex flex-col justify-between h-full'>
            <img src="https://build.zas.media/images/noticia-4.jpg"/>
            <div className='relative h-full p-3 app-text'>
              <p className='font-bold app-secondary text-xl'>Inteligência Artificial Preverá Terremotos com 48 Horas de Antecedência</p>
              <p className='mt-4'>Pesquisadores de uma universidade americana anunciaram um avanço revolucionário na previsão de terremotos. Utilizando um novo modelo de inteligência artificial, a equipe conseguiu prever tremores com até 48 horas de antecedência e 85% de precisão.</p>
              <p  className='mt-4'>O sistema, chamado de QuakeAI, analisa padrões sísmicos, mudanças na crosta terrestre e variações no campo</p>
            </div>
            <AppNavBar activeItem="more" />
          </div>
        </div>
      </div>
    </div>
  ),
  others: () => ( 
    <div className="mockup-phone">
      <div className="camera">
        <div className='text-white text-center'>Outros Elementos</div>
      </div>
      <div className="display pb-10 app-bg">
        <div className="artboard phone-1 app-mini">
          <div className='flex flex-col justify-between h-full '>
            <AppTopBar appBarPreview={appBarPreview} />
            <div className='canvas-bg p-3 font-bold text-base'>
              Fundo secundário
            </div>
            <div className="flex m-3 justify-between items-center">
              <p className='font-bold app-secondary text-xl '>Título</p>
              <button className="button font-bold py-2 px-4">
                Botão
              </button>
            </div>
            <p className='font-bold app-secondary-container text-base m-3'>Títulos com menos destaque</p>
            <div className='el flex m-3 p-2 items-center'>
              <div className='dev-date flex flex-col items-center'>
                <span className='font-bold text-lg'>28</span>
                <span className='font-bold'>out.</span>
              </div>
              <div>
                <p className='font-bold text-base'>Bem aventurados</p>
                <div className='dev-verse canvas-bg font-bold'>
                  Bem-aventurados os humildes de espírito, p...
                </div>
                <div className='dev-chapter font-bold mt-1'>Mateus 5:3</div>
              </div>
            </div>
            <div className='flex justify-around'>
              
            </div>
            <div className='flex items-center'>
              <div className='shimmer m-3'></div>
              <span className='font-bold'>Efeito de carregamento</span>
            </div>
            <AppNavBar activeItem="news" />
          </div>
        </div>
      </div>
    </div> 
  ),
  menu: () => ( 
    <div className="mockup-phone">
      <div className="camera">
        <div className='text-white text-center'>Menu</div>
      </div>
      <div className="display pb-10 app-bg">
        <div className="artboard phone-1 app-mini">
          <div className='flex flex-col justify-between h-full '>
            <div className="topbar">
              <span>12:00</span>
              <span>
                <i className="fas fa-wifi"></i>
                <i className="fas fa-signal"></i>
              </span>
            </div>
            <div className='relative h-full app-menu'>
              <div className='login p-3'>
                <span className='circle'>
                  <i className="fas fa-user"></i>
                </span>
                <div className='font-bold mt-4'>Faça o login ou crie uma conta</div>
              </div>
              <ul>
                <li>
                  <i className="fas fa-sign-in-alt text-xl"></i>
                  <div className='font-bold text-lg'>Entrar</div>
                  <i className="fa-solid fa-chevron-right text-xl"></i>
                </li>
                <li className='border-top'>
                  <i className="fas fa-bell text-xl"></i>
                  <div className='font-bold text-lg'>Notificações</div>
                </li>
                <li>
                  <i className="fas fa-list text-xl"></i>
                  <div className='font-bold text-lg'>Mensagens</div>
                  <i className="fa-solid fa-chevron-right text-xl"></i>
                </li>
                <li className='border-top'>
                  <i className="fas fa-share-alt text-xl"></i>
                  <div className='font-bold text-lg'>Compartilhar</div>
                  <i className="fa-solid fa-chevron-right text-xl"></i>
                </li>
                <li>
                  <i className="fas fa-star text-xl"></i>
                  <div className='font-bold text-lg'>Avaliar App</div>
                  <i className="fa-solid fa-chevron-right text-xl"></i>
                </li>
                <li className='border-top'>
                  <i className="fas fa-phone-volume text-xl"></i>
                  <div className='font-bold text-lg'>Fale Conosco</div>
                  <i className="fa-solid fa-chevron-right text-xl"></i>
                </li>
                <li className='border-top'>
                  <i className="fas fa-sticky-note text-xl"></i>
                  <div className='font-bold text-lg'>Termos de Uso</div>
                  <i className="fa-solid fa-chevron-right text-xl"></i>
                </li>
              </ul>
            </div>
            <AppNavBar activeItem="more" />
          </div>
        </div>
      </div>
    </div>
  ),
  intro: () => (
      <div className="mockup-phone">
      <div className="camera">
        <div className='text-white text-center'>Intro</div>
      </div>
      <div className="display pb-10 app-bg">
        <div className="artboard phone-1">
          <div className='flex justify-center items-center app-intro'>
            <img src={logoPreview} className='app-logo' alt="App Bar" />
          </div>
        </div>
      </div>
    </div>
  ),
});

export default AppTopBar;